export default  [
  {
    path: "/apps/dashboard/home/",
    name: "apps-dashboard-home",
    /*
    route level code-splitting: this generates a separate chunk (analytics.[hash].js) for this route, 
    which is lazy-loaded when the route is visited
    */
    component: () => import('./home/Home.vue'),
    meta: {
      authRequired: true,
      resource: "dashboard",
      action: "read"
    }
  },
  {
    path: "/apps/dashboard/analytics/",
    name: "apps-dashboard-analytics",
    /*
    route level code-splitting: this generates a separate chunk (analytics.[hash].js) for this route, 
    which is lazy-loaded when the route is visited
    */
    component: () => import('@/0-dashboard/analytics/Analytics.vue'),
    meta: {
      authRequired: true,
      resource: "dashboard",
      action: "read"
    }
  },
]
